<template>
  <div>
    <ul class="list-group">
      <li :class="['list-group-item', selectedItem.locationCode == item.locationCode ? 'selected' : '']" v-for="(item, index) in locationList" :key="index" @click="idcSelect(item)">
        <p>{{item.locationName}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['locationList', 'selected'],
  watch: {
    selected() {
      this.selectedItem = this.selected;
    }
  },
  data(){
    return {
      selectedItem: this.selected
    }
  },
  methods: {
    idcSelect(item){
      var that = this;
      setTimeout(()=>{
        that.selectedItem = item;
        that.$emit('idcSelect', item);
      })
    }
  }
}
</script>

<style>

</style>
